
import {
  UsuarioPerfil,
  TokenAcesso,
  UserIdentity,
  UserCredential
} from '../index';


export class Usuario {
  "codigo";
  "email";
  "Matricula";
  "PersonalNumber";
  "emailVerified";
  "username";
  "nomeCompleto";
  "realm";
  "Cadastro";
  "forcarAlteracaoSenha";
  "CodigoPerfil";
  "password";
  UsuarioPerfil;
  accessTokens;
  identities;
  credentials;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Usuario`.
   */
  static getModelName() {
    return "Usuario";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Usuario for dynamic purposes.
  **/
  static factory(data) {
    return new Usuario(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'Usuario',
      plural: 'Usuarios',
      path: 'Usuarios',
      properties: {
        "codigo": {
          name: 'codigo',
          type: 'number'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "Matricula": {
          name: 'Matricula',
          type: 'string'
        },
        "PersonalNumber": {
          name: 'PersonalNumber',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "nomeCompleto": {
          name: 'nomeCompleto',
          type: 'string'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "Cadastro": {
          name: 'Cadastro',
          type: 'Date'
        },
        "forcarAlteracaoSenha": {
          name: 'forcarAlteracaoSenha',
          type: 'boolean'
        },
        "CodigoPerfil": {
          name: 'CodigoPerfil',
          type: 'number'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        UsuarioPerfil: {
          name: 'UsuarioPerfil',
          type: 'UsuarioPerfil',
          model: 'UsuarioPerfil'
        },
        accessTokens: {
          name: 'accessTokens',
          type: 'TokenAcesso[]',
          model: 'TokenAcesso'
        },
        identities: {
          name: 'identities',
          type: 'UserIdentity[]',
          model: 'UserIdentity'
        },
        credentials: {
          name: 'credentials',
          type: 'UserCredential[]',
          model: 'UserCredential'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Usuario.js